import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Column from '/src/data/auto-generated/pagebuilder/lib/ContentTypes/Column/column.md';
import ColumnGroup from '/src/data/auto-generated/pagebuilder/lib/ContentTypes/ColumnGroup/columnGroup.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "column-and-columngroup"
    }}>{`Column and ColumnGroup`}</h1>
    <h2 {...{
      "id": "column"
    }}>{`Column`}</h2>
    {/*
     The reference doc content is generated automatically from the source code.
     To update this section, update the doc blocks in the source code
     */}

    <Column mdxType="Column" />
    <h2 {...{
      "id": "columngroup"
    }}>{`ColumnGroup`}</h2>
    {/*
     The reference doc content is generated automatically from the source code.
     To update this section, update the doc blocks in the source code
     */}

    <ColumnGroup mdxType="ColumnGroup" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      